import React, { useEffect, useState } from "react";

import { CloseGreyIcon } from "../../../assets/icons";
import { Switch } from "@mui/material";
import { NotificationType } from "../../../models/base/NotificationType";
import { useNotification } from "../../toster-notification/NotificationContext";
import Loader from "../../shared/Loader";
import { notificationService } from "../../../services/notificationService";
import { useParams } from "react-router-dom";

interface EditNotificationViewProps {
    notificationId: string;
    onClose: () => void;
}

const EditNotificationView: React.FC<EditNotificationViewProps> = ({ onClose, notificationId }) => {

    const [name, setName] = useState("");
    const [nameError, setNameError] = useState("");
    const [description, setDescription] = useState("");
    const [descriptionError, setDescriptionError] = useState("");
    const [notificationType, setNotificationType] = useState<NotificationType>(NotificationType.Info);
    const [isActive, setIsActive] = useState(false);

    const [loading, setLoading] = useState(false);

    const { notify } = useNotification();

    const { localId } = useParams<{ localId: string }>();

    useEffect(() => {
        fetchNotificationDetails();
    }, [notificationId]);

    const fetchNotificationDetails = async () => {
        if (!localId) {
            notify("error", "Local ID is missing.");
            return;
        }

        if (!notificationId) {
            notify("error", "Notification ID is missing.");
            return;
        }

        setLoading(true);

        try{
            const response = await notificationService.getNotificationInfo(localId, notificationId);

            if(response.success && response.data){
                setName(response.data.title);
                setDescription(response.data.message);
                setNotificationType(response.data.notificationType);
                setIsActive(response.data.isActive);
            } else {
                notify("error", response.message || "Došlo je do greške prilikom učitavanja notifikacije.");
            }
        }catch(error){
            notify("error", "Došlo je do greške prilikom učitavanja notifikacije.");
        }finally{
        setLoading(false);
        }
    };

    const handleUpdate = async () => {

        if (!localId) {
            notify("error", "Local ID is missing.");
            return;
        }

        setNameError("");
        setDescriptionError("");

        let valid = true;

        if (name.trim() === "") {
            setNameError("Naslov je obavezan.");
            valid = false;
        }

        if (description.trim() === "") {
            setDescriptionError("Poruka je obavezna.");
            valid = false;
        }

        if (!valid) return;

        setLoading(true);

        try {   

            const response = await notificationService.updateNotification(localId, notificationId, {
                title: name,
                message: description,
                notificationType,
                isActive
            });

            if (response.success) {
                notify("success", "Notifikacija je uspešno kreirana.");
                onClose();
            } else {
                notify("error", response.message || "Došlo je do greške prilikom kreiranja notifikacije.");
            }
        } catch (error) {
            notify("error", "Došlo je do greške prilikom kreiranja notifikacije.");
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return < Loader />;
    }

    return (
        <section className="modal-section notification">
            <div className="w-layout-blockcontainer container w-container">
                <div className="modal-wrapper">
                    <div className="modal-div">
                        <div className="modal-header-div">
                            <div>
                                <div className="modal-header">Nova notifikacija</div>
                                <div className="description-text">
                                    Kreirajte poruku koja će se prikazati gostima<br />
                                </div>
                            </div>
                            <div className="modal-button-div" onClick={onClose}>
                                <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" />
                            </div>
                        </div>
                        <div className="modal-form-block w-form">
                            <form className="modal-form">

                                <div className="modal-form-div">
                                    <label className="modal-form-label">Naslov *</label>
                                    <input className="form-input grey w-input" placeholder="Unesi naslov" type="text"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                    <div className="error-text">{nameError}</div>
                                </div>

                                <div className="modal-form-div">
                                    <label className="modal-form-label">Poruka *</label>
                                    <textarea placeholder="Unesi poruku" className="form-textarea grey w-input"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                    ></textarea>
                                    <div className="error-text">{descriptionError}</div>
                                </div>

                                <div className="modal-form-div">
                                    <label className="modal-form-label">Tip notifikacije</label>
                                    <select className="form-select auto-width w-select"
                                        value={notificationType}
                                        onChange={(e) => setNotificationType(Number(e.target.value) as NotificationType)}
                                    >

                                        {Object.keys(NotificationType)
                                            .filter(key => isNaN(Number(key)))
                                            .map((type) => (
                                                <option key={type} value={NotificationType[type as keyof typeof NotificationType]}>
                                                    {type}
                                                </option>
                                            ))
                                        }

                                    </select>
                                </div>

                                <div className="modal-form-div f-horizontal">
                                    <label className="modal-form-label">Aktivna notifikacija*</label>
                                    <Switch
                                        checked={isActive}
                                        onChange={(e) => setIsActive(e.target.checked)}
                                    />
                                </div>

                            </form>
                        </div>
                        <div className="modal-buttons">
                            <div className="button-secondary medium" onClick={onClose}>
                                <div>Otkaži</div>
                            </div>
                            <div className="button-primary medium" onClick={() => handleUpdate()}>
                                <div>Ažuriraj</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );

}

export default EditNotificationView;